import React from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const FeatureToggles = ({ config, onUpdate }) => {
  const handleToggleChange = (field, value) => {
    onUpdate({ [field]: value });
  };

  const features = [
    {
      key: 'streaming_enabled',
      label: 'Streaming Responses',
      description: 'Enable real-time streaming of AI responses',
      icon: 'Zap',
      defaultValue: true
    },
    {
      key: 'audio_enabled',
      label: 'Audio Support',
      description: 'Allow voice input and audio responses',
      icon: 'Mic',
      defaultValue: false
    },
    {
      key: 'vision_enabled',
      label: 'Vision Capabilities',
      description: 'Enable image analysis and vision features',
      icon: 'Eye',
      defaultValue: false
    },
    {
      key: 'show_sources',
      label: 'Show Sources',
      description: 'Display knowledge base sources in responses',
      icon: 'FileText',
      defaultValue: true
    },
    {
      key: 'debug_mode',
      label: 'Debug Mode',
      description: 'Show detailed debugging information',
      icon: 'Bug',
      defaultValue: false
    }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Icon name="Toggles" size={20} className="mr-2 text-primary" />
          Feature Configuration
        </h3>

        <div className="space-y-4">
          {features?.map((feature) => (
            <div key={feature?.key} className="flex items-start space-x-3 p-3 rounded-lg border border-border bg-background/50">
              <Checkbox
                id={feature?.key}
                checked={config?.[feature?.key] ?? feature?.defaultValue}
                onChange={(e) => handleToggleChange(feature?.key, e?.target?.checked)}
                className="mt-1"
              />
              <div className="flex-1">
                <label 
                  htmlFor={feature?.key}
                  className="flex items-center text-sm font-medium text-foreground cursor-pointer mb-1"
                >
                  <Icon name={feature?.icon} size={16} className="mr-2 text-primary" />
                  {feature?.label}
                </label>
                <p className="text-xs text-muted-foreground">
                  {feature?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeatureToggles;